import { render, staticRenderFns } from "./VideoViewer.vue?vue&type=template&id=1a4f47de&scoped=true&"
import script from "./VideoViewer.vue?vue&type=script&lang=js&"
export * from "./VideoViewer.vue?vue&type=script&lang=js&"
import style0 from "./VideoViewer.vue?vue&type=style&index=0&id=1a4f47de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f47de",
  null
  
)

export default component.exports